import { styled } from '@mui/material/styles'
import { Box, Menu, Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { MuiButton } from '../../../components'
import { filter } from '../../../assets/images/icons'

export const OuterWrapper = styled(Box)(
  (props) => `
  width:100%;
  display:flex;
  flex-direction: column;
  ${props.showRHS ? 'max-width: calc(100vw - 460px - 120px);' : 'max-width: calc(100vw - 90px - 460px);'};
`
)

export const SelectedFilters = styled(Box)(`
  width:100%;
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  padding-top: 12px;
  padding-left: 20px;
  position: relative;

  & .filterIcon {
    position: absolute;
    top: 16px;
    left: 0;
  }
`)

export const ChipLabel = styled('span')(`
  padding-right:10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`)

export const SelectedChip = styled(Box)(`
  cursor:pointer;
  display:flex;
  align-items:center;
  background-color:#E7F0FF;
  border-radius:2px;
  margin-left:4px;
  margin-bottom:4px;
  height: 24px;
  line-height: 24px;
  padding: 0 6px 0 12px;
  border-radius: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #242424;
  & svg{ margin-left:5px;}
`)

export const ActionFilters = styled(Box)(`
  width:100%;
  display:flex;
  justify-content:end;
  gap: 8px;
`)

export const FilterButton = styled(MuiButton)(`
  height: 34px;
  background: #F1F6FF url(${filter}) no-repeat 15px center;
  border: 1px solid #F1F6FF;
  background-size: 18px;
  padding:0 15px 0 40px;
  color:#000;
  font-weight: 400; // 300;
  &:hover{
    background-color: #F1F6FF;
  }
`)

export const MenuOuterWrapper = styled(Menu)(`
  & .MuiPaper-elevation {
    border-radius:0 !important;
  }
  & .MuiMenu-paper {
    margin-left:-20px !important;
    margin-top:5px !important;
  }
  & ul {
    padding: 12px 0 !important
    // padding:0 !important;
  }
`)

export const MenuInnerWrapper = styled(Box)(`
  width: 360px;
`)

export const AccordionWrapper = styled(Accordion)(`
  margin: 0 !important;
  box-shadow:none;
  &:before {display:none;}
`)

export const AccordionHeading = styled(AccordionSummary)(`
  padding: 0px 20px;
  & p {
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
  }
`)

export const AccordionContent = styled(AccordionDetails)(`
  display:flex;
  flex-direction:column;
  background:#F5F5F5;
  max-height:180px;
  overflow-y:auto;
  & span {
    font-weight: 400; // 300;
    font-size: 12px;
    line-height: 14px;
  }
`)

export const FilterButtonWrap = styled(Box)(`
  position:relative;
`)
